// 研修营移动端骨架路由。页面在 src/views/researchCamp。
// 列表不在这里：只改现有 /zoneList，增加「研修营」页签。
// 答题页不复用 /gradeQuestion，也不调用班级考试接口。
import campMine from '@/views/researchCamp/mine'
import campDetail from '@/views/researchCamp/detail'
import campStudents from '@/views/researchCamp/students'
import campArchive from '@/views/researchCamp/archive'
import campCompleted from '@/views/researchCamp/completed'
import campCustomTasks from '@/views/researchCamp/customTasks'
import campCustomTaskCreate from '@/views/researchCamp/customTaskCreate'
import campCustomTaskDetail from '@/views/researchCamp/customTaskDetail'
import campExam from '@/views/researchCamp/exam'

export const researchCampRouterMap = [
  {
    path: '/researchCamp/mine',
    name: '我的研修营',
    meta: {
      moduleName: '研修营'
    },
    component: campMine
  },
  {
    path: '/researchCamp/detail',
    name: '研修营详情',
    meta: {
      moduleName: '研修营'
    },
    component: campDetail
  },
  {
    path: '/researchCamp/students',
    name: '研修营学员名单',
    meta: {
      moduleName: '研修营'
    },
    component: campStudents
  },
  {
    path: '/researchCamp/archive',
    name: '研修营培训档案',
    meta: {
      moduleName: '研修营'
    },
    component: campArchive
  },
  {
    path: '/researchCamp/completed',
    name: '研修营已完成学员',
    meta: {
      moduleName: '研修营'
    },
    component: campCompleted
  },
  {
    path: '/researchCamp/customTasks',
    name: '研修营定制任务',
    meta: {
      moduleName: '研修营'
    },
    component: campCustomTasks
  },
  {
    path: '/researchCamp/customTaskCreate',
    name: '创建研修营定制任务',
    meta: {
      moduleName: '研修营'
    },
    component: campCustomTaskCreate
  },
  {
    path: '/researchCamp/customTaskDetail',
    name: '研修营定制任务详情',
    meta: {
      moduleName: '研修营'
    },
    component: campCustomTaskDetail
  },
  {
    path: '/researchCamp/exam',
    name: '研修营答题',
    meta: {
      moduleName: '研修营'
    },
    component: campExam
  }
]



// WEBPACK FOOTER //
// ./src/router/researchCamp.js